module.exports = __webpack_public_path__ + "img/common-section-image01.2644a1d8.png";